// extracted by mini-css-extract-plugin
export default {"wpp":"WhatsApp_wpp__5sv3J"};